import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { IconDeviceFloppy, IconSquareX } from "@tabler/icons-react";

const DetailPpsComp = (props) => {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="langkahPemenuhan" className="form-label required">
              Langkah Pemenuhan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="langkahPemenuhan"
              value={props.itemPps.langkahPemenuhan}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="metodePerbaikan" className="form-label required">
              Metode Perbaikan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="metodePerbaikan"
              value={props.itemPps.metodePerbaikan}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="jangkaWaktuPerbaikan"
              className="form-label required"
            >
              Jangka Waktu Perbaikan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="jangkaWaktuPerbaikan"
              value={
                props.itemPps.jangkaWaktuPerbaikan === 1
                  ? "Kurang dari 3 Bulan"
                  : props.itemPps.jangkaWaktuPerbaikan === 2
                  ? "Antara 3 - 6 Bulan"
                  : props.itemPps.jangkaWaktuPerbaikan === 3
                  ? "Antara 6 - 9 Bulan"
                  : props.itemPps.jangkaWaktuPerbaikan === 4
                  ? "Lebih dari 9 Bulan"
                  : ""
              }
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="indikatorPencapaian"
              className="form-label required"
            >
              Indikator Pencapaian
            </label>
            <textarea
              className="form-control row-cols-3"
              id="indikatorPencapaian"
              value={props.itemPps.indikatorPencapaian}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="periodeAwal" className="form-label required">
              Periode Awal
            </label>
            <textarea
              className="form-control row-cols-3"
              id="periodeAwal"
              value={props.itemPps.periodeAwal}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="periodeAkhir" className="form-label required">
              Periode Akhir
            </label>
            <textarea
              className="form-control row-cols-3"
              id="periodeAkhir"
              value={props.itemPps.periodeAkhir}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="kategoriPeriode" className="form-label required">
              Kategori Periode
            </label>
            <textarea
              className="form-control row-cols-3"
              id="kategoriPeriode"
              value={props.itemPps.kategoriPeriode}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="pic" className="form-label required">
              PIC
            </label>
            <textarea
              className="form-control row-cols-3"
              id="pic"
              value={props.itemPps.pic}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <div className="mb-5">
            <label htmlFor="keterangan" className="form-label required">
              Keterangan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="keterangan"
              value={props.itemPps.keterangan}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-4">
          <div className="mb-5">
            <label htmlFor="catatan" className="form-label required">
              Catatan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="catatan"
              value={props.itemPps.catatan}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-4">
          <div className="mb-5">
            <label htmlFor="kategoriPerbaikan" className="form-label required">
              Kategori Perbaikan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="kategoriPerbaikan"
              value={props.itemPps.kategoriPerbaikan}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="statusItemPps" className="form-label required">
              Status Item PPS
            </label>
            <textarea
              className="form-control row-cols-3"
              id="statusItemPps"
              value={
                props.itemPps.statusItemPps === 1
                  ? "Solved by Surveior"
                  : "Pending by Surveior"
              }
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="syncSpeakOnline" className="form-label required">
              Status Sinkron SPEAK Online
            </label>
            <textarea
              className="form-control row-cols-3"
              id="syncSpeakOnline"
              value={props.itemPps.syncSpeakOnline}
              disabled={true}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </>
  );
};

export default DetailPpsComp;
